import React, { useState, useEffect } from 'react';
import * as CandidateService from "@app/services/CandidateService";
import { showSuccessMessageSaveData } from "@pages/candidate/Common";
import { toast } from "react-toastify";
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";

const CtvInfoCard = ({
    candidateId,
    initialInfoAsCtv,
    onChange,
    mode = 'Edit', // Default to Edit mode for backward compatibility
    isEditCtvInfo = false
}) => {
    const [isEdit, setIsEdit] = useState(isEditCtvInfo);
    const [infoAsCtv, setInfoAsCtv] = useState({is_ctv: "", ctv_type: ""});

    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        setInfoAsCtv(initialInfoAsCtv || {is_ctv: "", ctv_type: ""});
    }, [initialInfoAsCtv]);

    const onChangeInfo = (event) => {
        infoAsCtv[event.target.name] = event.target.value;
        setInfoAsCtv({...infoAsCtv});

        if (onChange) {
            onChange(infoAsCtv);
        }
    };

    const fetchInfoAsCtv = (canId) => {
        // setIsLoading(true)
        CandidateService.getInfoAsCtv(canId).then((res) => {
            setInfoAsCtv({...res.content})
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            // setIsLoading(false)
        });
    };

    useEffect(() => {
        if (candidateId && userLoginInfo?.is_superuser) {
            fetchInfoAsCtv(candidateId);
        }
    }, [candidateId, userLoginInfo]);

    const updateInfoAsCtv = (fields) => {
        // setIsLoading(true)
        let payload = {candidate_id: candidateId}
        fields.forEach(field => {
            payload[field] = infoAsCtv[field]
        })
        CandidateService.updateInfoAsCtv({info_as_ctv: payload}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEdit(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            // setIsLoading(false)
        });
    };

    const handleSave = () => {
        updateInfoAsCtv(['is_ctv', 'industry_as_ctv', 'note_ctv', 'ctv_type']);
    };

    // Auto-save in Search mode when infoAsCtv changes
    // useEffect(() => {
    //     if (mode === 'Search' && onSave) {
    //         onSave(['is_ctv', 'industry_as_ctv', 'note_ctv', 'ctv_type'], infoAsCtv);
    //     }
    // }, [infoAsCtv, mode, onSave]);

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Thông tin CTV</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setIsEdit(false);
                                    }}
                            >
                                Cancel
                            </button>
                        }
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={handleSave}
                            >
                                Save
                            </button>
                        }
                        {!isEdit &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEdit(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                )}
            </div>
            <div className='card-body'>
                <div className='input-group'>
                    <label className={'w-100'}>Là CTV?</label>
                    <select className='form-control'
                            name={'is_ctv'}
                            disabled={!isEdit}
                            value={infoAsCtv.is_ctv || ''}
                            onChange={onChangeInfo}>
                        <option value=''>&nbsp;</option>
                        <option value='true'>Là CTV</option>
                        <option value='false'>Không phải</option>
                    </select>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Industry Function (as a CTV)</label>
                    <input type='text' className='form-control'
                           disabled={!isEdit}
                           value={infoAsCtv.industry_as_ctv || ''}
                           name={'industry_as_ctv'}
                           onChange={onChangeInfo}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Note (CTV)</label>
                    <input type='text' className='form-control'
                           disabled={!isEdit}
                           value={infoAsCtv.note_ctv || ''}
                           name={'note_ctv'}
                           onChange={onChangeInfo}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Kiểu CTV</label>
                    <select className='form-control'
                            name={'ctv_type'}
                            disabled={!isEdit}
                            value={infoAsCtv.ctv_type || ''}
                            onChange={onChangeInfo}>
                        <option value=''>&nbsp;</option>
                        <option value='1'>HRM, HRD</option>
                        <option value='2'>Recruiter</option>
                        <option value='3'>Cdds & others</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default CtvInfoCard;


